import { CircularProgress, LinearProgress } from "@mui/material";
import useScreenDimensions from "../hooks/useScreenDimensions";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { datasource } from "../datasource/datasource";

const loadingText =
  "Your zip file is being prepared. This will only take a moment";

const completeText = "Your download is starting";

export const SharedLinkPage = () => {
  const { width, height } = useScreenDimensions();

  const { reviewHash } = useParams();

  const aTagRef = useRef<HTMLAnchorElement>(null);

  const [hasStarted, setHasStarted] = useState<boolean>(false);
  const [hasFailed, setHasFailed] = useState<boolean>(false);

  useEffect(() => {
    if (reviewHash) {
      datasource.getPublicZip(reviewHash).then(async (res) => {
        if (!res.ok) {
          setHasFailed(true);
        } else {
          setHasStarted(true);
          const blob = await res.blob();
          const blobUrl = window.URL.createObjectURL(blob);
          res.headers.forEach((value, name) => console.log(name, value));
          if (aTagRef.current) {
            aTagRef.current.href = blobUrl;
            aTagRef.current.download = `${res.headers.get("Reviewname")}.zip`;
            aTagRef.current.click();
            window.URL.revokeObjectURL(blobUrl);
          }
        }
      });
    }
  }, []);

  return (
    <div
      style={{
        width,
        height,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={"/logoForLoading.png"} />
      <>
        {!hasStarted && !hasFailed ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {loadingText?.length ? (
              <div style={{ marginRight: "1rem" }}>{loadingText}</div>
            ) : (
              ""
            )}
            <CircularProgress />
          </div>
        ) : (
          hasFailed ? 'This review either does not exist or is not shared' : completeText
        )}{" "}
      </>
      <a ref={aTagRef} style={{ display: "none" }} />
    </div>
  );
};
